import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var SellersApi = function () {
    function SellersApi(axios, store) {
        _classCallCheck(this, SellersApi);

        this.axios = axios;
    }

    _createClass(SellersApi, [{
        key: 'getSellersData',
        value: function getSellersData(idTeam) {
            return this.axios.$post('/sellers/sellers/list-names', idTeam);
        }
    }, {
        key: 'updatePasswordSeller',
        value: function updatePasswordSeller(data) {
            return this.axios.$post('/sellers/sellers/update-password', data);
        }
    }, {
        key: 'createdNewSeller',
        value: function createdNewSeller(data) {
            return this.axios.$post('/sellers/sellers/new-Seller', data);
        }
    }, {
        key: 'getSellersManagement',
        value: function getSellersManagement(data) {
            return this.axios.$post('/sellers/sellers/find-Seller-Management', data);
        }
    }, {
        key: 'findSellerById',
        value: function findSellerById(data) {
            return this.axios.$post('/sellers/sellers/find-Seller-by-id', data);
        }
    }, {
        key: 'editSeller',
        value: function editSeller(data) {
            return this.axios.$post('/sellers/sellers/edit-Seller', data);
        }
    }, {
        key: 'editSellerManagement',
        value: function editSellerManagement(data) {
            return this.axios.$post('/sellers/sellers/edit-seller-management', data);
        }
    }, {
        key: 'validSellersEmail',
        value: function validSellersEmail(data) {
            return this.axios.$post('/sellers/sellers/validation-email', data);
        }
    }, {
        key: 'validationDocumentNumberSeller',
        value: function validationDocumentNumberSeller(data) {
            return this.axios.$post('/sellers/sellers/validation-document-number', data);
        }
    }, {
        key: 'validationPasswordSellers',
        value: function validationPasswordSellers(data, cancelToken) {
            return this.axios.$post('/sellers/sellers/validation-password', data, { cancelToken: cancelToken });
        }
    }, {
        key: 'chargeSeller',
        value: function chargeSeller(data) {
            // console.log('Viendo los vendedores: ', data)
            return this.axios.$post('/sellers/sellers/chargue-Seller', data);
        }
    }]);

    return SellersApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/sellers.js
// module id = ./src/api/sellers.js
// module chunks = 34